import { useSelector, useDispatch } from 'react-redux'
import { ArrowLeftIcon, IconButton } from '@buffer-mono/popcorn'

import { setShowChannelStorefront } from '../../../../../../store/channelConnectionsReducer'
import type { OrchestratorRootState } from '../../../../../../../../common/events/types'

export function BackButton({ onBack }: { onBack?: () => void }): JSX.Element {
  const dispatch = useDispatch()
  const { cta } = useSelector(
    (state: OrchestratorRootState) => state.channelConnections,
  )

  function backToChannelStorefront(): void {
    dispatch(setShowChannelStorefront({ cta }))
  }

  if (onBack) {
    return (
      <IconButton
        onClick={(): void => onBack()}
        label="Back"
        variant="tertiary"
        size="small"
      >
        <ArrowLeftIcon />
      </IconButton>
    )
  }

  return (
    <IconButton
      onClick={backToChannelStorefront}
      label="Back to channel storefront"
      variant="tertiary"
      size="small"
    >
      <ArrowLeftIcon />
    </IconButton>
  )
}
